export const CANDIDATE_REPORT = "CANDIDATE_REPORT"
export const CANDIDATE_REPORT_SUCCESSFUL = "CANDIDATE_REPORT_SUCCESSFUL"
export const CANDIDATE_REPORT_FAILED = "CANDIDATE_REPORT_FAILED"

export const CANDIDATE_REPORT_DOWNLOAD = "CANDIDATE_REPORT_DOWNLOAD"
export const CANDIDATE_REPORT_DOWNLOAD_SUCCESSFUL = "CANDIDATE_REPORT_DOWNLOAD_SUCCESSFUL"
export const CANDIDATE_REPORT_DOWNLOAD_FAILED = "CANDIDATE_REPORT_DOWNLOAD_FAILED"

export const JOB_REPORT = "JOB_REPORT"
export const JOB_REPORT_SUCCESSFUL = "JOB_REPORT_SUCCESSFUL"
export const JOB_REPORT_FAILED = "JOB_REPORT_FAILED"

export const JOB_REPORT_DOWNLOAD = "JOB_REPORT_DOWNLOAD"
export const JOB_REPORT_DOWNLOAD_SUCCESSFUL = "JOB_REPORT_DOWNLOAD_SUCCESSFUL"
export const JOB_REPORT_DOWNLOAD_FAILED = "JOB_REPORT_DOWNLOAD_FAILED"

export const JOB_PERFORMANCE_REPORT = "JOB_PERFORMANCE_REPORT"
export const JOB_PERFORMANCE_REPORT_SUCCESSFUL = "JOB_PERFORMANCE_REPORT_SUCCESSFUL"
export const JOB_PERFORMANCE_REPORT_FAILED = "JOB_PERFORMANCE_REPORT_FAILED"

export const JOB_PERFORMANCE_REPORT_DOWNLOAD = "JOB_PERFORMANCE_REPORT_DOWNLOAD"
export const JOB_PERFORMANCE_REPORT_DOWNLOAD_SUCCESSFUL = "JOB_PERFORMANCE_REPORT_DOWNLOAD_SUCCESSFUL"
export const JOB_PERFORMANCE_REPORT_DOWNLOAD_FAILED = "JOB_PERFORMANCE_REPORT_DOWNLOAD_FAILED"